import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {Menu, MenuItem} from '../../meta.menu';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {faArrowLeft, faArrowUp, faArrowDown, faArrowRight, faPlus, faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'lib-menu-item-view',
    templateUrl: './menu-item-view.component.html',
    styleUrls: ['./menu-item-view.component.css'],
})
export class MenuItemViewComponent implements OnInit {

  @Input()
  public menu: Menu | null;

  @Input()
  public menuItem: MenuItem | null;

  @Output()
  public menuItemAdded = new EventEmitter<MenuItem>();

  @Output()
  public menuItemDeleted = new EventEmitter<MenuItem>();

  @Output()
  menuItemMoved = new EventEmitter<number>();

  @Output()
  menuItemMenuMoved = new EventEmitter<number>();

  mouseActive = false;

  menuItemForm: FormGroup;
  modalRef?: BsModalRef;

  faArrowLeft = faArrowLeft;
  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  faArrowRight = faArrowRight;
  faPlus = faPlus;
  faEdit = faEdit;
  faTrash = faTrash;

  constructor(
    protected readonly fb: FormBuilder,
    protected readonly modalService: BsModalService) {
    this.menuItemForm = this.fb.group({
      label: [''],
      route: [''],
    });
  }

  ngOnInit(): void {
  }

  @HostListener('mouseenter')
  mouseenter() {
    this.mouseActive = true;
  }

  @HostListener('mouseleave')
  mouseleave() {
    this.mouseActive = false;
  }

  onEditMenuItem(content: any) {
    if(this.menuItem) {
      this.menuItemForm.patchValue(this.menuItem);
      this.modalRef = this.modalService.show(content, {ariaLabelledBy: 'modal-basic-title'});
      this.modalRef.onHide?.subscribe((reason) => {
        console.log(`dismissed: ${reason}`);
      });
    }
  }

  onAdd() {
    if(this.menu && this.menuItem) {
      const menuItem = new MenuItem();
      menuItem.label = 'Label';
      menuItem.route = '/route/here';
      this.menuItemAdded.next(menuItem)
    }
  }

  onMove(direction: number) {
    this.menuItemMoved.next(direction);
  }

  onMenuMoved(direction: number) {
    this.menuItemMenuMoved.next(direction);
  }

  onDelete() {
    if(this.menuItem) {
      this.menuItemDeleted.next(this.menuItem);
    }
  }

  onCancel() {
    this.modalRef?.hide();
  }

  onSave() {
    this.modalRef?.hide();
    if(this.menuItem) {
      const editedItem = this.menuItemForm.value;
      console.log(`Edited item: ${JSON.stringify(editedItem)}`);
      this.menuItem = Object.assign(this.menuItem, editedItem);
    }
  }
}
